import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React from 'react';
import { LOCALE, CURRENCY, CURRENCY_DISPLAY } from './defaults';
import defaultLocales from './locales';
import { extend } from './component-helper';
export function prepareContext() {
  let props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const locales = props.locales ? extend(defaultLocales, props.locales) : defaultLocales;
  if (props.__context__) {
    Object.assign(props, props.__context__);
    delete props.__context__;
  }
  const key = handleLocaleFallbacks(props.locale || LOCALE, locales);
  const translation = locales[key] || defaultLocales[LOCALE] || {};
  if (locales[key]) {
    locales[key] = destruct(locales[key], translation);
  }
  const context = _objectSpread(_objectSpread({
    updateTranslation: (locale, translation) => {
      context.translation = context.locales[locale] = translation;
    },
    getTranslation: props => {
      if (props) {
        const lang = props.lang || props.locale;
        if (lang && context.locales[lang] && lang !== key) {
          return context.locales[lang];
        }
      }
      return context.translation;
    },
    locales,
    locale: null,
    breakpoints: null,
    skeleton: null
  }, props), {}, {
    translation
  });
  return context;
}
function handleLocaleFallbacks(locale, locales) {
  if (!locales[locale]) {
    if (locale === 'en' || locale.split('-')[0] === 'en') {
      return 'en-GB';
    }
  }
  return locale;
}
const Context = React.createContext(prepareContext({
  locale: LOCALE,
  currency: CURRENCY,
  currency_display: CURRENCY_DISPLAY
}));
export default Context;
function destruct(source, validKeys) {
  for (const k in source) {
    if (String(k).includes('.')) {
      const list = k.split('.');
      if (validKeys[list[0]]) {
        const val = source[k];
        const last = list.length - 1;
        list.forEach((k, i) => {
          source[k] = i === last ? val : source[k];
          source = source[k] || {};
        });
      }
    }
  }
  return source;
}
//# sourceMappingURL=Context.js.map